import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-analise-margem-bi02-lista-grid',
  templateUrl: './analise-margem-bi02-lista-grid.component.html',
  styleUrls: [ './../../../../../../../assets/styles/styles.grid-analise.css']
})
export class AnaliseMargemBi02ListaGridComponent implements OnInit {

  analiseMargemTranslate = {
    "Margem Bruta MO": "rmpv.analiseMargem.margemMO",
    "Margem Bruta Peças Cliente": "rmpv.analiseMargem.margemPecaCliente",
    "Margem Bruta Peças Seguros/Franquias": "rmpv.analiseMargem.margemPecaSeguro",
    "Margem Bruta Peças Garantia": "rmpv.analiseMargem.margemPecaGarantia",
    "Margem Bruta Peças Recall": "rmpv.analiseMargem.margemPecaRecall",
    "Margem Bruta Peças Revisões": "rmpv.analiseMargem.margemRevisoes",
    "Margem Bruta Acessórios Oficina": "rmpv.analiseMargem.margemAcessorioOficina",
    "Margem Bruta Acessórios Balcão": "rmpv.analiseMargem.margemAcessorioBalcao",
    "Margem Bruta Clothing": "rmpv.analiseMargem.margemClothing",
    "Margem Bruta Outros": "rmpv.analiseMargem.margemOutros",
    "Bônus PCA": "rmpv.analiseMargem.bonusPCA",
    "Margem Bruta Total PCA": "rmpv.analiseMargem.margemBrutaTotalPCA",
    "Margem Bruta Total MO + PCA": "rmpv.analiseMargem.margemBrutaTotalMOPCA",
    "% Margem Bruta MO + PCA": "rmpv.analiseMargem.percentualMargemBrutaMOPCA",
    "Despesas Departamentais": "rmpv.analiseMargem.despesaDepartamental",
    "% Despesas": "rmpv.analiseMargem.percentualDespesas",
    "Resultado Operacional PV": "rmpv.analiseMargem.resultadoOperacionalPV",
    "% Resultado Operacional": "rmpv.analiseMargem.percentualResultadoOperacional",
    "Despesas Administrativas da Revenda": "rmpv.analiseMargem.despesaAdministrativa",
    "% Taxa de Absorção": "rmpv.analiseMargem.taxaAbsorcao"
    };

  @Input() dados: any;
  @Input() anoFiltro: any;

  constructor() { }

  ngOnInit(): void {
  }

  getTranslate(value) {
    return this.analiseMargemTranslate[value];
  }  

}
